import React from "react";
import "../styles/Ice.css"; // Make sure this file is correctly linked

const Ice = () => {
  return (
    <div id="ice" className="ice-container container">
      {/* Top Video */}
      <div className="video-top mb-4">
        <video controls className="video-medium">
          <source src="bhanotvideo.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <p className="ice-content">At Bhanot International LLC, we bring you the Item Compatibility Engine™ (ICE)—a powerful big data suite of software, hardware, products, and services designed to meet your business needs with precision and efficiency.ICE is built on a vast library of hundreds of thousands of electronic devices, accessories, and components, each meticulously verified for extreme accuracy. This extensive data repository ensures seamless compatibility and enables businesses to optimize operations, reduce errors, and enhance productivity.Originally developed and refined in-house, ICE is now available to the industry, providing cutting-edge solutions that empower businesses with unmatched accuracy and efficiency.</p>
      </div>
      <hr/>
      {/* Bottom Video with Text */}
      <div className="video-text-group d-flex align-items-center mt-4">
        <video controls className="video-medium">
          <source src="Icecheck.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="text-content ms-3">
          <h5>IMEI Check Service</h5>
          <p>
            IMEI Check allows you to check one or many IMEIs at a time, verifying
            whether they are whitelisted, stolen, or still under contract.
          </p>
          <a href="#ice-registration" className="register-link">Register Here</a>
        </div>
      </div>
      {/* Bottom Video with Text */}
      <div className="video-text-group d-flex align-items-center mt-4">
        <video controls className="video-medium">
          <source src="IceX.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="text-content ms-3">
          <h5>ICE-X SERVICES</h5>
          <p>
          ICEX enhances ICE with AI-driven insights and real-time data, optimizing product matching and business efficiency.
          </p>
          <a href="#ice-registration" className="register-link">Register Here</a>
        </div>
      </div>
      <hr/> 
    </div>

  );
};

export default Ice;